import { inject, observer } from 'mobx-react';
import { GlobalTracker } from '@/utils/Tracker';
import styles from './index.module.less';
import dynamic from 'next/dynamic';

const UserMenuList = dynamic(import('./UserMenuList'), { ssr: false });

const Personal = inject(
  'area',
  'auth',
  'app',
  'reseller',
  'meta'
)(
  observer((props) => {
    const {
      meta: { navCurStyle },
    } = props;

    const onClickIcon = () => {
      GlobalTracker.navigation({ action: 'click_personal_center' });
    };

    return (
      <div className={styles.Personal}>
        <button
          className={styles.btn}
          style={{ backgroundImage: `url('${navCurStyle?.personalIcon}')`, width: 48, height: 48 }}
          onClick={onClickIcon}
        />
        <UserMenuList />
      </div>
    );
  })
);

export default Personal;
